/* BASIQ · Scroll suave desde las estrellas hasta el widget de reseñas de Loox */
(function () {
  'use strict';

  var LOOX_SELECTORS = [
    '#looxReviews',
    '[id^="looxReviews"]',
    '.loox-reviews-default',
    '.loox-reviews-widget',
    '.loox-widget',
    '[data-loox-widget]',
    '[class*="loox-reviews"]'
  ];

  var MAX_TRIES = 12;   // ~1,8 s esperando a que Loox pinte el widget
  var TRY_DELAY = 150;

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function findLoox() {
    for (var i = 0; i < LOOX_SELECTORS.length; i++) {
      var list = document.querySelectorAll(LOOX_SELECTORS[i]);
      for (var j = 0; j < list.length; j++) {
        if (isVisible(list[j])) return list[j];
      }
    }
    return null;
  }

  /* Subimos hasta la sección completa para no cortar el título del bloque */
  function resolveTarget(el) {
    var section = el.closest('.shopify-section, [id^="shopify-section-"]');
    return section && isVisible(section) ? section : el;
  }

  function headerOffset() {
    var header = document.querySelector('.basiq-header');
    var h = header ? header.getBoundingClientRect().height : 0;
    return h + 20;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function smoothScrollTo(targetY) {
    var maxY = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight
    );
    var endY = Math.max(0, Math.min(targetY, maxY));
    var startY = window.pageYOffset || document.documentElement.scrollTop;
    var distance = endY - startY;

    if (Math.abs(distance) < 2) return;

    var reduced =
      window.matchMedia &&
      false;

    if (reduced) {
      window.scrollTo(0, endY);
      return;
    }

    /* Duración proporcional a la distancia, con topes para que siempre se sienta igual */
    var duration = Math.min(1400, Math.max(650, Math.abs(distance) * 0.5));
    var start = null;
    var cancelled = false;

    function cancel() {
      cancelled = true;
    }

    window.addEventListener('wheel', cancel, { passive: true, once: true });
    window.addEventListener('touchstart', cancel, { passive: true, once: true });

    function step(timestamp) {
      if (cancelled) return;
      if (start === null) start = timestamp;

      var elapsed = timestamp - start;
      var progress = Math.min(1, elapsed / duration);

      window.scrollTo(0, startY + distance * easeInOutCubic(progress));

      if (progress < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function goToReviews(attempt) {
    var el = findLoox();

    if (!el) {
      if (attempt < MAX_TRIES) {
        window.setTimeout(function () {
          goToReviews(attempt + 1);
        }, TRY_DELAY);
      }
      return;
    }

    var target = resolveTarget(el);
    var y =
      target.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop) -
      headerOffset();

    smoothScrollTo(y);
  }

  /* Delegado en document: sobrevive a las recargas de sección del editor de Shopify */
  document.addEventListener('click', function (event) {
    var trigger =
      event.target && event.target.closest
        ? event.target.closest('[data-bp-scroll-reviews]')
        : null;

    if (!trigger) return;

    event.preventDefault();
    goToReviews(0);
  });
})();
